import * as React from 'react';

import { cn } from '@/lib/utils';

export interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export function Label({ className, ...props }: LabelProps) {
    return (
        <label
            className={cn(
                'opacity-0 bg-stroke text-white absolute p-1 rounded-[2px] -top-4 left-4 text-[12px] transition-opacity duration-500 peer-focus:opacity-100',
                className
            )}
            {...props}
        />
    );
}
